export default __webpack_public_path__ + "static/media/ic_fil_40.55d7a9f7.svg";